import React from 'react';
import moment from 'moment-timezone';
import { connect } from 'react-redux';

import Parse from '../../Parse';
import Spinner from '../../components/UI/Spinner/Spinner';

import './Reports.css';
import Swal from 'sweetalert2';
import Filter from '../../helpers/Filter';
import ValidationError from '../../helpers/ValidationError';
// import ControlStation from '../Outlet/ControlStation/ControlStation';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import Axios from 'axios';
import Configs from '../../Configs';
import ControlStation from './ControlStation/ControlStation';

import * as actions from '../../store/actions';
import ReportActivities from './Activities/ReportActivities';
import ReportsAction from './Actions/Reports';
import DeleteAction from './Actions/Deletes';
import DeleteActivities from './Activities/DeleteActivities';
import User from './User/User';

const ranges = {
    'Today': [moment(), moment()],
    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
    'This Year': [moment().startOf('year'), moment().endOf('year')],
    'Last Year': [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')]
}

const initialSettings = {
    name: {
        tax1: "Tax 1",
        tax2: "Tax 2",
        taxBeforeDiscount: "Tax Before Discount",
        netTaxBeforeDiscount: "Net Tax Before Discount"
    },
    currencyFormat: {
        thousandSeparator: ",",
        decimalSeparator: ".",
        decimalPlace: "2"
    },
    openingClosingTime: {
        openingHour: "00:00:00",
        closingHour: "23:59:59",
        cutTimeOff: "08:00:00"
    },
    inventorySummary: {
        displayValue: 0
    },
    mealTime: {
        1: "Night",
        2: "Night",
        3: "Night",
        4: "Night",
        5: "Night",
        6: "Breakfast",
        7: "Breakfast",
        8: "Breakfast",
        9: "Breakfast",
        10: "Breakfast",
        11: "Lunch",
        12: "Lunch",
        13: "Lunch",
        14: "Lunch",
        15: "Snack",
        16: "Snack",
        17: "Snack",
        18: "Dinner",
        19: "Dinner",
        20: "Dinner",
        21: "Dinner",
        22: "Dinner",
        23: "Dinner",
        24: "Dinner"
    }
}

const GROUP_DELETE = [
    "remove-user",
    "remove-device"
];

class Reports extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            type: null,
            periods: [],
            functions: [],
            activities: [],
            deleteActivities: [],
            loadingGenerate: false,
            loadingGenerateDelete: false,
            messages: "",
            ownerId: "",
            owner: {},
            controllerIds: [],
            controllerNames: {},
            sessionToken: null,
            settings: {}
        }
    }

    componentDidMount = () => {
        if(this.props.match.params.ownerId !== this.props.ownerId) {
            this.props.removeOutlets();
        }
        this.getSessionTokenHandler();
    }

    componentDidUpdate = () => {
        if(this.props.ownerId !== undefined && this.props.ownerId !== null && this.props.match.params.ownerId !== this.props.ownerId) {
            this.getSessionTokenHandler(() => {
                this.props.removeOutlets();
            });
        }
    }

    changeControllerIdsHandler = () => {
        this.setState({
            loading: true
        }, () => {
            this.setState({
                loading: false
            })
        })
    }

    changeInputHandler = (e) => {
        const value = e.target.value;
        this.setState({
            type: value
        })
    }

    fetchActivityReports = () => {
        this.setState({
            loading: true
        })
        const last30days = moment().subtract(30, "days");
        const activityReports = new Parse.Query("activityReports");
        activityReports.greaterThan("createdAt", last30days.toDate());
        activityReports.descending("updatedAt");
        activityReports.limit(5);
	    activityReports.find({
            sessionToken: this.state.sessionToken
        }).then(results => {
            if(results.length > 0){
                this.setState({
                    loading: false,
                    activities: [
                        ...results
                    ]
                })
            }
            else {
                this.setState({
                    loading: false,
                })
            }
        });		
    }

    fetchActivityRemovedReports = () => {
        this.setState({
            loading: true
        })
        const activityDeletedReports = new Parse.Query("activityDeleteReports");
        activityDeletedReports.equalTo("owner", this.props.ownerId);
        activityDeletedReports.descending("updatedAt");
        activityDeletedReports.limit(5);
	    activityDeletedReports.find().then(results => {
            if(results.length > 0){
                this.setState({
                    loading: false,
                    deleteActivities: [
                        ...results
                    ]
                })
            }
            else {
                this.setState({
                    loading: false,
                })
            }
        });		
    }

    resendEmailVerify = () => {
        const user = Parse.User.current();
        user.set("email", user.get("email"));
        user.save().then(results => {
            Swal.fire('The verify email has sent to your email, please check your email');
        });		
    }

    requestGenerateReport = (type, email, isPrivate) => {
        const controllerNames = this.props.controllerNames;
        const periods = [...this.state.periods];
        const user = Parse.User.current();

        const periodsReq = periods.map(value => {
            return {
                name: value.name,
                range: {
                    start: (new Date(value.range.start)).getTime(),
                    end: (new Date(value.range.end)).getTime(),
                },
                rangeOpenCloseBalance: {
                    start: moment((value.range.start)).format("YYYY-MM-DD HH:mm:ss"),
                    end: moment((value.range.end)).format("YYYY-MM-DD HH:mm:ss"),
                }
            }
        })

        const settings = {...this.state.settings};

        let params = {
            "periods": [...periodsReq],
            "token": Configs.adminToken,
            "controllerIds": this.props.controllerIds,
            "controllerNames": controllerNames,
            "timeZone": moment.tz.guess(),
            "mealTime": settings.mealTime || {},
            "isPrivate": isPrivate,
            "openingClosingTime": settings.openingClosingTime || {},
            "name": settings.name || {},
            "inventorySummary": settings.inventorySummary || {},
            "_ApplicationId": Configs.parseReportsApplicationId,
            "_SessionToken": this.state.sessionToken,
            "_method": "POST"
        };

        if(email !== null) {
            if(!ValidationError(email, {
                isEmail: true
            })) {
                this.setState({
                    messages: "Email is invalid"
                })
                return;
            }
            params = {
                ...params,
                email: email
            }
        } else {
            const userEmailIsVerify = user.get("emailVerified");
            if(userEmailIsVerify == undefined || !userEmailIsVerify) {
                Swal.fire({
                    title: "Email is not verified",
                    text: 'Please verify the email and logout the aboss, try again!',
                    showCancelButton: true,
                    confirmButtonText: 'Resend',
                    showLoaderOnConfirm: true,
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        this.resendEmailVerify();
                    }
                    this.setState({
                        messages: 'Email is not verified, Please verify the email and logout the aboss, try again!',
                    })
                })
                return;
            }
        }

        this.setState({
            loadingGenerate: true
        })

        Axios.post(`${Configs.parseReportsServerURL}/functions/${type}`, params).then((res) => {
            if(res.data.result) {
                this.setState({
                    loadingGenerate: false,
                    messages: 'Report will be generated in the cloud. When it has completed, email notification will be sent or you can check back here after a while.',
                }, () => {
                    this.fetchActivityReports();
                })
            }
            else {
                Swal.fire(res.data.message);
                this.setState({
                    loadingGenerate: false,
                    messages: res.data.message,
                })
            }
        }).catch(res => {
            const response = res.response;
            Swal.fire(response.data.error);
            this.setState({
                loadingGenerate: false,
                messages: "Error Generate Report",
            })
        })
    }

    generateReportHandler = () => {
        const user = Parse.User.current();
        const type = this.state.type;
        if(!type) {
            this.setState({
                inProgress: true,
                messages: 'Please choose the Backgroud Job Type'
            })
            return;
        }

        Swal.fire({
            html: `
                <p>Report will be generated in the cloud. When it has completed, email notification will be sent or you can check back here after a while. Please input email you want to send, Once the report is generated, it will send to the following email!</p>
                <div class="choose_data_import">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="choose_is_private_report" checked>
                        <label class="form-check-label" for="choose_is_private_report">
                            Private Report?
                        </label>
                    </div>
                </div>
            `,
            input: 'text',
            inputValue: user.get('email'),
            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Generate',
            showLoaderOnConfirm: true,
            reverseButtons: true
        }).then((result) => {
            if (result.value) {
                this.setState({
                    messages: "Report will be generated in the cloud. When it has completed, email "+ result.value +" notification will be sent or you can check back here after a while."
                }, () => {
                    const isPrivate = document.getElementById('choose_is_private_report').checked;
                    this.requestGenerateReport(type, result.value, isPrivate);
                })
            }
            else {
                this.setState({
                    messages: "Cancel for generating report"
                })
            }
        })
    }

    requestGenerateRemoved = (type, owner, controller) => {
        const user = Parse.User.current();
        let params = {
            "_ApplicationId": Configs.parseReportsApplicationId,
            "_SessionToken": user.get('sessionToken'),
            "_method": "POST"
        };

        if(owner && (type === "remove-user" || type === "remove-device")) {
            params = {
                owner: owner,
                ...params
            }
        }
        if(controller && type === "remove-device") {
            params = {
                controller: controller,
                ...params
            }
        }

        this.setState({
            loadingGenerateDelete: true
        })

        Axios.post(`${Configs.parseReportsServerURL}/functions/${type}`, params).then((res) => {
            if(res.data.result) {
                this.setState({
                    loadingGenerateDelete: false,
                    messages: 'Removing will be generated in the cloud. When it has completed.',
                }, () => {
                    this.fetchActivityRemovedReports();
                })
            }
            else {
                Swal.fire(res.data.message);
                this.setState({
                    loadingGenerateDelete: false,
                    messages: res.data.message,
                })
            }
        }).catch(res => {
            const response = res.response;
            Swal.fire(response.data.error);
            this.setState({
                loadingGenerateDelete: false,
                messages: "Error Generate Remove",
            })
        })
    }

    generateRemoveHandler = () => {
        const type = this.state.type;
        const controllerIds = [...this.props.controllerIds];
        const owner = {...this.state.owner};
        const controller = controllerIds[0] !== undefined && controllerIds[0] ? controllerIds[0] : null;
        const username = owner.username !== undefined && owner.username ? owner.username : null;

        if(!type) {
            this.setState({
                inProgress: true,
                messages: 'Please choose the Backgroud Job Type'
            })
            return;
        }
        if(!GROUP_DELETE.includes(type)) {
            this.setState({
                inProgress: true,
                messages: 'Please choose the Correct Backgroud Job'
            })
            return;
        }
        let title = "";
        let confirm = "";
        switch(type) {
            case ("remove-device"):
                title = "Device";
                if(!username || !controller) {
                    this.setState({
                        inProgress: true,
                        messages: 'No Owner or Controller'
                    })
                    return;
                }
                confirm = controller;
                break;
            case ("remove-user"):
                title = "User";
                if(!username) {
                    this.setState({
                        inProgress: true,
                        messages: 'No Owner or Controller'
                    })
                    return;
                }
                confirm = username;
                break;
            default:
                this.setState({
                    inProgress: true,
                    messages: 'Please choose the Correct Backgroud Job'
                })
                return;
        }

        Swal.fire({
            title: `Remove ${title}`,
            html: `
                <p>By Remove ${title}, you'll permanently remove all of its transactions from Cloud Storage. Removing is performed in background and may take some time depending on transaction's size</p>
                <p>Confirm the removing by typing the ${title} bellow: ${confirm}</p>
            `,
            icon: 'warning',
            input: 'text',
            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            confirmButtonColor: '#dd4b39',
            showLoaderOnConfirm: true,
            reverseButtons: true
        }).then((result) => {
            if (result.value) {
                if(confirm !== result.value) {
                    this.setState({
                        messages: "Confirm value is not correct"
                    })
                    return;
                }
                this.requestGenerateRemoved(type, owner.objectId, controller);
            }
            else {
                this.setState({
                    messages: "Cancel for Remove " + title
                })
            }
        })
    }

    refreshActivityReports = () => {
        const options = {...this.state.options};
        this.setState({
            options: {
                ...options,
                start: moment().subtract(6, 'days'),
                end: moment()
            },
        }, () => {
            this.fetchActivityReports();
        })
    }

    refreshActivityDeleteReports = () => {
        const options = {...this.state.options};
        this.setState({
            options: {
                ...options,
                start: moment().subtract(6, 'days'),
                end: moment()
            },
        }, () => {
            this.fetchActivityRemovedReports();
        })
    }

    getOpeningHour = (settings) => {
        const settingTimes = settings.openingClosingTime || {};
        return {
            openingHour: settingTimes.openingHour || "00:00:00",
            closingHour: settingTimes.closingHour || "23:59:59",
            cutTimeOff: settingTimes.cutTimeOff || "08:00:00"
        }
    }

    addPeriodHandler = () => {
        let limit = 2;
        let periods = [...this.state.periods];
        const currentUser = Parse.User.current();
        const limitPeriodTimeRangeReport = currentUser.get('limitPeriodTimeRangeReport');
        if(limitPeriodTimeRangeReport !== undefined &&
            limitPeriodTimeRangeReport > limit
        ) {
            limit = limitPeriodTimeRangeReport;
        }
        if(periods.length >= limit) {
            this.setState({
                disablePeriodButton: true
            })
            return;
        }
        const index = periods.length + 1; 

        const start = moment().subtract(6, 'days');
        const end = moment();

        const settings = {...this.state.settings};

        const openingClosingTime = this.getOpeningHour(settings);

        let updateStart = Filter.getStartDateByCutOffTime(start, openingClosingTime);
        let updateEnd = Filter.getEndDateByCutOffTime(end, openingClosingTime);
        
        let momentStart = moment(updateStart);
        let momentEnd = moment(updateEnd);

        periods.push({
            name: "Period " + index,
            range: {
                start: momentStart,
                end: momentEnd
            },
            datePickerRange: {
                start: start,
                end: end,
            }
        })
        this.setState({
            periods: [
                ...periods,
            ]
        })
    }

    changeNamePeriod = (value, index) => {
        let periods = [...this.state.periods];
        periods[index] = {
            ...periods[index],
            ["name"]: value
        }
        this.setState({
            periods: [
                ...periods,
            ]
        })
    }

    changeDateHandler = (picker, index) => {

        const start = picker.startDate;
        const end = picker.endDate;

        const settings = {...this.state.settings};
        const openingClosingTime = this.getOpeningHour(settings);

        let updateStart = Filter.getStartDateByCutOffTime(start, openingClosingTime);
        let updateEnd = Filter.getEndDateByCutOffTime(end, openingClosingTime);
        
        let momentStart = moment(updateStart);
        let momentEnd = moment(updateEnd);
        let periods = [...this.state.periods];
        periods[index] = {
            ...periods[index],
            range: {
                start: momentStart,
                end: momentEnd
            },
            datePickerRange: {
                start: start,
                end: end
            },
        }

        this.setState({
            periods: [
                ...periods
            ]
        })
    }

    choosedOwnerHandler = (ownerId, sessionToken, settings) => {
        if(ownerId == undefined || !ownerId) {
            Swal.fire({
                title: "The ownerId required"
            });
            return;
        }
        if(sessionToken == undefined || !sessionToken) {
            Swal.fire({
                title: "The Session Token required"
            });
            return;
        }
        this.setState({
            ownerId: ownerId,
            sessionToken: sessionToken,
            settings: settings
        }, () => {
            localStorage.setItem(`${ownerId}_token`, sessionToken);
        })
    }

    choosedControllerHandler = (controllerIds, controllerNames) => {
        if(controllerIds == undefined || !controllerIds || controllerIds.length <= 0) {
            Swal.fire({
                title: "The Controller required"
            });
            return;
        }
        localStorage.setItem(`${this.state.ownerId}_control_station_name`, JSON.stringify(controllerNames));
        this.setState({
            controllerIds: controllerIds,
            controllerNames: controllerNames
        }, () => {
            this.fetchActivityReports();
            this.fetchActivityRemovedReports();
        })
    }

    getSettings = () => {
        const Settings = Parse.Object.extend("settings");
        const settingsQuery = new Parse.Query(Settings);
        settingsQuery.first({
            sessionToken: this.state.sessionToken
        }).then((result) => {
            const typesSettings = Object.keys(initialSettings);
            let settingsState = {...initialSettings};
            if(result) {
                const typesSettingsLength = typesSettings.length;
                for(let i = 0; i < typesSettingsLength; i++) {
                    const type = typesSettings[i];
                    if(type == undefined) {
                        continue;
                    }
                    const typeValue = result.get(type);
                    if(typeValue == undefined) {
                        continue;
                    }
                    if(!typeValue) {
                        settingsState = {
                            ...settingsState,
                            [type]: typeValue[type]
                        }
                    }
                    else {
                        settingsState = {
                            ...settingsState,
                            [type]: typeValue
                        }
                    }
                }
            }
            this.setState({
                settings: settingsState,
            }, () => {
                localStorage.setItem(this.state.ownerId + "_settings", JSON.stringify(this.state.settings));

                const start = moment().subtract(6, 'days');
                const end = moment();

                const settings = {...this.state.settings};
                const openingClosingTime = this.getOpeningHour(settings);

                let updateStart = Filter.getStartDateByCutOffTime(start, openingClosingTime);
                let updateEnd = Filter.getEndDateByCutOffTime(end, openingClosingTime);
                
                let momentStart = moment(updateStart);
                let momentEnd = moment(updateEnd);

                this.setState({
                    periods: [
                        {
                            name: "Period 1",
                            range: {
                                start: momentStart,
                                end: momentEnd,
                            },
                            datePickerRange: {
                                start: start,
                                end: end,
                            }
                        }
                    ]
                })
                this.validateLoadOwnerHandler()
            })
        });
    }

    validateLoadOwnerHandler = () => {
        const ownerId = this.state.ownerId;
        const sessionToken = this.state.sessionToken;
        const settings = this.state.settings;
        if(ownerId == undefined || !ownerId) {
            Swal.fire({
                title: "The ownerId required"
            });
            return;
        }
        if(sessionToken == undefined || !sessionToken) {
            Swal.fire({
                title: "The Session Token required"
            });
            return;
        }
        this.choosedOwnerHandler(ownerId, sessionToken, settings);
    }

    getSessionTokenHandler = (callback) => {
        this.setState({
            loadingGetToken: true,
        });
        const ownerId = this.props.match.params.ownerId;
        const user = Parse.User.current();
        if(ownerId == undefined || !ownerId) {
            Swal.fire({
                title: "The ownerId required"
            });
            return;
        }
        const params = {
            "owner": ownerId,
            "_ApplicationId": Configs.parseReportsApplicationId,
            "_SessionToken": user.get('sessionToken'),
            "_method": "POST"
        };

        Axios.post(`${Configs.parseReportsServerURL}/functions/get-token-by-owner`, params).then((res) => {
            if(res.data.result) {
                const result = res.data.result;
                this.setState({
                    loadingGetToken: false,
                    ownerId: ownerId,
                    owner: result.owner || {},
                    functions: result.configs || [],
                    sessionToken: result.token
                }, () => {
                    if(callback !== undefined) {
                        callback();
                    }
                    this.getSettings();
                    this.fetchActivityReports();
                    this.fetchActivityRemovedReports();
                })
            }
            else {
                Swal.fire(res.data.message);
                this.setState({
                    loadingGetToken: false,
                    messages: res.data.message,
                })
            }
        }).catch(res => {
            if(res.data != undefined && res.data.message != undefined) {
                Swal.fire(res.data.message);
                this.setState({
                    loadingGetToken: false,
                    messages: res.data.message,
                })
            }
        })
    }

    restoreHandler = (objectId) => {
        this.setState({
            loadingGenerateDelete: true,
        });
        if(objectId == undefined || !objectId) {
            Swal.fire({
                title: "The Object Id required"
            });
            return;
        }
        const user = Parse.User.current();
        const params = {
            "activityId": objectId,
            "_ApplicationId": Configs.parseReportsApplicationId,
            "_SessionToken": user.get('sessionToken'),
            "_method": "POST"
        };
        Axios.post(`${Configs.parseReportsServerURL}/functions/backup`, params).then((res) => {
            if(res.data.result) {
                this.setState({
                    loadingGenerateDelete: false,
                    messages: 'Restore will be generated in the cloud. When it has completed, email notification will be sent or you can check back here after a while.',
                }, () => {
                    this.fetchActivityRemovedReports();
                })
            }
            else {
                Swal.fire(res.data.message);
                this.setState({
                    loadingGenerateDelete: false,
                    messages: res.data.message,
                })
            }
        }).catch(res => {
            const response = res.response;
            Swal.fire(response.data.error);
            this.setState({
                loadingGenerateDelete: false,
                messages: "Error Restore",
            })
        })
    }

    render () {
        const messages = this.state.messages;
        let content = (
            <div className="box box-default">
                <div className="box-header with-border"></div>
                <div className="box-body">
                    <div className="col-xs-12 col-md-12 col-lg-12 table-responsive no-padding">
                        <Spinner></Spinner>
                    </div>
                </div>
            </div>
        );

        if(this.state.loadingGetToken) {
            return (
                <Spinner></Spinner>
            )
        }

        const periods = [...this.state.periods];
        const periodsContent = periods.map((value, index) => {
            const start = value.datePickerRange.start;
            const end = value.datePickerRange.end;
            return (
                <div key={index} className="period row">
                    <div className="col-md-3 col-xs-12 col-lg-3 periodName">
                        <div className="form-group">
                            <input className="form-control" value={value.name} onChange={(e) => this.changeNamePeriod(e.target.value, index)} />
                        </div>
                    </div>
                    <div className="col-md-9 col-xs-12 col-lg-9 outletDatePicker">
                        <DateRangePicker startDate={start} endDate={end} ranges={ranges} onApply={(e, picker) => {
                                return this.changeDateHandler(picker, index);
                            }}>
                            <div className="detailDateRage">
                                <i className="fa fa-calendar"></i>&nbsp;
                                <span>{start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY')}</span> <i className="fa fa-caret-down"></i>
                            </div>
                        </DateRangePicker>
                    </div>  
                    <div className="clearfix"></div>
                </div>
            )
        })

        if(!this.state.loading) {
            if(!GROUP_DELETE.includes(this.state.type)) {
                const activities = [...this.state.activities];
                content = (
                    <ReportActivities {...this.props} activities={activities} refresh={this.refreshActivityReports}></ReportActivities>
                )
            }
            else {
                const deleteActivities = [...this.state.deleteActivities];
                content = (
                    <DeleteActivities {...this.props} activities={deleteActivities} refresh={this.refreshActivityDeleteReports} restore={this.restoreHandler}></DeleteActivities>
                )
            }
        }

        const ownerId = this.state.ownerId;
        const owner = {...this.state.owner};
        const functions = [...this.state.functions];
        const token = this.state.sessionToken;

        return (
            <div className="Reports">
                <div className="row">
                    {
                        ownerId && token ? (
                            <React.Fragment>
                                <div className="col-md-12 col-xs-12 col-lg-12">
                                    <User owner={owner}></User>
                                </div>
                                <div className="col-md-12 col-xs-12 col-lg-12">
                                    <ControlStation token={token} ownerId={ownerId} title="Control Station (Outlet)" isCombineController={true} save={this.choosedControllerHandler} isOwner={"owner"}></ControlStation>
                                </div>
                            </React.Fragment>
                        ) : null
                    }
                    {
                        ownerId && token ? (
                            <div className="col-md-12 col-xs-12 col-lg-12">
                                <div className="box box-default">
                                    <div className="box-header with-border">
                                        <h3 className="box-title">Background Jobs</h3>
                                    </div>
                                    <div className="box-body">
                                        <div className="row">
                                            <div className="col-md-4 col-lg-4 col-xs-12">
                                                <div className="form-group">
                                                    <select className="form-control" onChange={(e) => this.changeInputHandler(e)}>
                                                        <option value="">Choose the job</option>
                                                        {
                                                            functions.map((func, key) => {
                                                                return (
                                                                    <option key={key} value={func.function}>{func.label}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            {
                                                !(GROUP_DELETE).includes(this.state.type) ? (
                                                    <div className="col-md-8 col-lg-8 col-xs-12">
                                                        {periods && periods.length > 0 ? periodsContent : null}
                                                    </div>
                                                ) : null
                                            }
                                        </div>
                                    </div>
                                    {
                                        !(GROUP_DELETE).includes(this.state.type) ? (
                                            <div className="box-footer">
                                                <ReportsAction loading={this.state.loadingGenerate} generate={this.generateReportHandler} addPeriod={this.addPeriodHandler} disabled={this.state.disablePeriodButton}></ReportsAction>
                                            </div>
                                        ) : (
                                            <div className="box-footer">
                                                <DeleteAction loading={this.state.loadingGenerateDelete} generate={this.generateRemoveHandler}></DeleteAction>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        ) : null
                    }
                    
                </div>
                {
                    ownerId && token ? (
                        <div className="row">
                            <div className="col-md-12 col-xs-12 col-lg-12">
                                {
                                    messages ? (
                                        <div className="alert alert-warning alert-dismissible">
                                            <h4><i className="icon fa fa-warning"></i> Information!</h4>
                                            {messages}
                                        </div>
                                    ) : null
                                }
                            </div>
                            <div className="col-md-12 col-xs-12 col-lg-12">
                                {content}
                            </div>
                        </div>
                    ) : null
                }
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        controllerIds: state.outlet.controllerIds,
        controllerNames: state.outlet.controllerNames,
        ownerId: state.outlet.owner
    };
};

const mapDispatchToProps = dispatch => {
    return {
        removeOutlets: () => {
            return dispatch( actions.removeOutlets() );
        }
    };
};

export default connect( mapStateToProps, mapDispatchToProps ) (Reports);